import { Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'finder-trip-advisor',
    templateUrl: './trip-advisor.component.html',
    styleUrls: ['./trip-advisor.component.scss']
})
export class TripAdvisorComponent implements OnInit {

    @Input() public reviews: any;

    constructor() { }

    ngOnInit() {
        if (this.reviews.reviewImage && this.reviews.reviewImage.alt) {
            this.reviews.reviewImage.alt = this.reviews.reviewImage.alt
                .replace('{entity}', this.reviews.entity)
                .replace('{rating}', this.reviews.reviewRating);
        }

        if (this.reviews.ariaLabel) {
            this.reviews.ariaLabel = this.reviews.ariaLabel
                .replace('{entity}', this.reviews.entity);
        }
    }
}
